import Text from '../../components/Text';
import { t } from '../../i18n/langue';

/**
 * Une case de checklist ou de préparation : la LIGNE entière est le libellé, donc
 * la zone tactile fait toute la largeur et au moins 44 px — pas les 20 px de la case.
 */
interface CaseACocherProps {
    libelle: string;
    /** Le libellé français quand `libelle` est sa traduction : écrit en petit dessous (T1). */
    original?: string | null;
    detail?: string | null;
    coche: boolean;
    onChange: () => void;
    desactive?: boolean;
    /** Le point bloque la fin du ménage tant qu'il n'est pas coché. */
    obligatoire?: boolean;
    /** Signalé par la dernière tentative de fin : le point qui manque. */
    enDefaut?: boolean;
}

export default function CaseACocher({
    libelle,
    original,
    detail,
    coche,
    onChange,
    desactive = false,
    obligatoire = false,
    enDefaut = false,
}: CaseACocherProps) {
    return (
        <label
            className={`flex min-h-touch items-center gap-3 rounded-xl bg-white px-3 py-2 ${
                enDefaut ? 'border border-alert-text-color' : ''
            }`}
        >
            <input
                type="checkbox"
                checked={coche}
                disabled={desactive}
                onChange={onChange}
                // Le nom accessible est le libellé seul : le détail et la mention
                // « obligatoire » sont portés à part (description, aria-required).
                aria-label={libelle}
                aria-required={obligatoire || undefined}
                aria-invalid={enDefaut || undefined}
                className="h-6 w-6 shrink-0 rounded border-border-color-light text-main-color"
            />
            <span className="min-w-0 flex-1">
                <Text variante="corps" as="span" className={`block ${coche ? 'line-through' : ''}`}>
                    {libelle}
                </Text>
                {original && (
                    <Text variante="petit" ton="attenue" as="span" className="block">
                        {original}
                    </Text>
                )}
                {detail && (
                    <Text variante="petit" ton="attenue" as="span" className="block">
                        {detail}
                    </Text>
                )}
            </span>
            {obligatoire && !coche && (
                <Text variante="petit" ton="danger" as="span" className="shrink-0">
                    {t('menage.case.obligatoire')}
                </Text>
            )}
        </label>
    );
}
